import { useAuth0 } from '@auth0/auth0-react'
import type { Auth0IdToken } from './types'

export function useAuth0Token() {
  const { getIdTokenClaims } = useAuth0()

  async function getRawAndClaims() {
    const claims = (await getIdTokenClaims()) as Auth0IdToken | undefined
    return {
      raw: claims?.__raw ?? '',
      claims,
    }
  }

  return { getRawAndClaims }
}
